export const categories = [
  {
    id: "football",
    name: "足球",
    icon: "ri-football-line",
    desc: "国内外各级足球联赛、杯赛与焦点对决的每日战报与赛程。",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    id: "basketball",
    name: "篮球",
    icon: "ri-basketball-line",
    desc: "职业与联赛级别篮球赛事，包含技术统计与球员状态追踪。",
    accent: "bg-accent-100 text-accent-700",
  },
  {
    id: "racing",
    name: "赛车",
    icon: "ri-roadster-line",
    desc: "方程式、耐力赛与场地竞速的排位、正赛及车队动态。",
    accent: "bg-secondary-100 text-secondary-700",
  },
  {
    id: "esports",
    name: "电竞",
    icon: "ri-gamepad-line",
    desc: "顶级电竞赛事小组赛、淘汰赛的赛程安排与战队黑榜。",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    id: "boxing",
    name: "拳击",
    icon: "ri-boxing-line",
    desc: "职业拳击卫冕战、挑战赛的回合数据与选手竞技状态。",
    accent: "bg-accent-100 text-accent-700",
  },
  {
    id: "other",
    name: "综合",
    icon: "ri-trophy-line",
    desc: "马拉松、综合体能等多项目赛事的资讯与安排汇总。",
    accent: "bg-secondary-100 text-secondary-700",
  },
];